import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import StripeProvider from './components/stripe/StripeProvider';

// Routes simplifiées
import SimpleRoutes from './routes/SimpleRoutes';

function App() {
  return (
    <StripeProvider>
      <Router>
        <div className="App">
          <SimpleRoutes />
        </div>
      </Router>
    </StripeProvider>
  );
}

export default App;
